import { useEffect } from 'react';

import { useCreateOnboardingState } from '@/hooks/useSwr';

import { useNewHomepageGetStartedAssignment } from './useNewHomepageGetStartedAssignment';

export const useCreateOnboardingStateOnLoad = () => {
  const newHomepageGetStartedAssignment = useNewHomepageGetStartedAssignment();

  const { trigger: createOnboardingState } = useCreateOnboardingState();

  useEffect(() => {
    if (newHomepageGetStartedAssignment === 'control') {
      return;
    }

    createOnboardingState({});
  }, [newHomepageGetStartedAssignment, createOnboardingState]);
};
